import React from 'react';

import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, Center, Text } from '@mantine/core';

interface ErrorStateProps {
  title?: string;
  message?: string;
  className?: string;
  style?: React.CSSProperties;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  title = 'Something went wrong',
  message = 'An unexpected error occurred. Please try again.',
  className,
  style
}) => {
  return (
    <Center className={className} style={style}>
      <Alert
        color="red"
        icon={<FontAwesomeIcon icon={faExclamationTriangle} size="xl" />}
        style={{ maxWidth: 500, width: '100%' }}
        title={title}
        variant="light"
      >
        <Text size="lg">{message}</Text>
      </Alert>
    </Center>
  );
};

export default ErrorState;
